<template>
  <div>
    <div class="stepContent">
      <el-row>
        <el-col :span="16">
          <ocf-workflow-card :options="optionsForComponents.ocfWorkflowCard" :data="dataForComponents.ocfWorkflowCard" @validate-init="onValidateInit"
            @validate-done="onValidateDone"></ocf-workflow-card>
        </el-col>
      </el-row>
    </div>
    <div class="stepFooter">
      <el-row class="cs-filter-row">
        <el-col>
          <el-button v-if="!isReadonly" size="medium" :disabled="submitBtnDisable" :type="submitBtnClass" @click="next">下一步</el-button>
          <el-button size="medium" type="danger" @click="onRedoWorkflow">新建流程</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.stepContent {
  padding: 20px 0px 0px 0px;
}

.stepFooter {
  .el-button {
    min-width: 98px;
  }
}
</style>

<script>
import ocfWorkflowCard from "./ocfWorkflowCard";

export default {
  props: {
    data: {
      priceSettings: Object,
      otherCollectFeeTypes: Array,
      memberShipYears: Array,
      bonusPointMechanisms: Object,
      bonusPointExchangeItems: Array,
      giftBalanceList: Array,
      workflowData: Object,
    },
  },
  data() {
    return {
      isReadonly: false,
      submitBtnDisable: false,
      submitBtnClass: "primary",
      priceSettings: null,
      otherCollectFeeTypes: [],
      memberShipYears: [],
      bonusPointMechanisms: null,
      bonusPointExchangeItems: [],
      giftBalanceList: [],
      workflowData: null,
      dataModel: {
        type: 0,
        feeYear: 0,
        subType: null,
        studentId: 0,
        phone: null,
        comment: null,
        amount: 0,
        quantity: 0,
        totalPrice: 0,
        bpeItemId: 0,
        bonusPointCost: 0,
        giftBalanceId: null,
        giftAmount: null,
        courseId: null,
      },
      oldDataModel: null,
      optionsForComponents: {
        ocfWorkflowCard: {
          enableEdit: true,
        },
      },
      dataForComponents: {
        ocfWorkflowCard: {
          priceSettings: null,
          otherCollectFeeTypes: [],
          memberShipYears: [],
          bonusPointMechanisms: null,
          bonusPointExchangeItems: [],
          giftBalanceList: [],
          ocfType: 0,
          subType: null,
          studentId: 0,
          phone: null,
          comment: null,
          amount: 0,
          quantity: 0,
          totalPrice: 0,
          bpeItemId: 0,
          bonusPointCost: 0,
          giftBalanceId: null,
          giftAmount: null,
          courseId: null,
        },
      },
    };
  },
  components: {
    ocfWorkflowCard,
  },
  computed: {
    isStudentTopUpBalance() {
      if (!this.USERMANAGER.isStudent) return false;
      return this.$route.name === "addCollectFeesTopUpBalance";
    },
  },
  created() {
    this.initData();
  },
  methods: {
    loadDataFromProps(data = this.data) {
      if (!!data) {
        this.priceSettings = data.priceSettings;
        this.otherCollectFeeTypes = data.otherCollectFeeTypes;
        this.bonusPointMechanisms = data.bonusPointMechanisms;
        this.bonusPointExchangeItems = data.bonusPointExchangeItems;
        this.giftBalanceList = data.giftBalanceList;
        this.memberShipYears = data.memberShipYears;
        this.workflowData = $.extend(true, {}, data.workflowData);
      } else {
        this.priceSettings = null;
        this.otherCollectFeeTypes = [];
        this.memberShipYears = [];
        this.bonusPointMechanisms = null;
        this.bonusPointExchangeItems = [];
        this.giftBalanceList = [];
        this.workflowData = null;
      }

      let typeItem = this.otherCollectFeeTypes.find(
        (item) => item.name === "topUpBalance"
      );
      if (!!this.workflowData) {
        this.isReadonly = this.workflowData.IsCompleted;
        this.dataModel.type = this.workflowData.Type;
        this.dataModel.feeYear = this.workflowData.FeeYear;
        this.dataModel.subType = this.workflowData.SubType;
        this.dataModel.studentId = this.workflowData.StudentId;
        this.dataModel.phone = this.workflowData.Phone;
        this.dataModel.comment = this.workflowData.Comment;
        this.dataModel.amount = this.workflowData.Amount;
        this.dataModel.quantity = this.workflowData.Quantity;
        this.dataModel.totalPrice = this.workflowData.TotalPrice;
        this.dataModel.bpeItemId = this.workflowData.BonusPointExchangeItemId;
        this.dataModel.bonusPointCost = this.workflowData.BonusPointCost;
        this.dataModel.giftBalanceId = this.workflowData.GiftBalanceId;
        this.dataModel.giftAmount = this.workflowData.GiftAmount;
        this.dataModel.courseId = this.workflowData.CourseId;

        if (this.isStudentTopUpBalance && !this.workflowData.Id) {
          this.dataModel.type = !!typeItem ? typeItem.value : 0;
          this.dataModel.phone = this.USERMANAGER.studentPhone;
        }
      } else {
        this.isReadonly = false;
        this.dataModel.type = 0;
        this.dataModel.feeYear = 0;
        this.dataModel.subType = null;
        this.dataModel.studentId = 0;
        this.dataModel.phone = null;
        this.dataModel.comment = null;
        this.dataModel.amount = 0;
        this.dataModel.quantity = 1;
        this.dataModel.totalPrice = 0;
        this.dataModel.bpeItemId = null;
        this.dataModel.bonusPointCost = 0;
        this.dataModel.giftBalanceId = null;
        this.dataModel.giftAmount = null;
        this.dataModel.courseId = null;

        if (this.isStudentTopUpBalance) {
          this.dataModel.type = !!typeItem ? typeItem.value : 0;
          this.dataModel.phone = this.USERMANAGER.studentPhone;
        }
      }

      this.oldDataModel = $.extend(true, {}, this.dataModel);
    },
    initData(data = this.data) {
      this.loadDataFromProps(data);
      this.reloadOptionsForComponents();
      this.reloadDataForComponents();
    },
    reloadOptionsForComponents() {
      let newOptions = {
        enableEdit: true,
      };

      newOptions.enableEdit = !this.isReadonly;

      this.optionsForComponents.ocfWorkflowCard = newOptions;
    },
    reloadDataForComponents() {
      let newData = {
        priceSettings: null,
        otherCollectFeeTypes: [],
        memberShipYears: [],
        bonusPointMechanisms: null,
        bonusPointExchangeItems: [],
        giftBalanceList: [],
        ocfType: 0,
        subType: null,
        studentId: 0,
        phone: null,
        comment: null,
        amount: 0,
        quantity: 0,
        totalPrice: 0,
        bpeItemId: null,
        bonusPointCost: 0,
        year: 0,
        giftBalanceId: null,
        giftAmount: null,
        courseId: null,
      };

      newData.priceSettings = this.priceSettings;
      newData.otherCollectFeeTypes = this.otherCollectFeeTypes;
      newData.memberShipYears = this.memberShipYears;
      newData.bonusPointMechanisms = this.bonusPointMechanisms;
      newData.bonusPointExchangeItems = this.bonusPointExchangeItems;
      newData.giftBalanceList = this.giftBalanceList;
      newData.ocfType = this.dataModel.type;
      newData.subType = this.dataModel.subType;
      newData.studentId = this.dataModel.studentId;
      newData.phone = this.dataModel.phone;
      newData.comment = this.dataModel.comment;
      newData.amount = this.dataModel.amount;
      newData.quantity = this.dataModel.quantity;
      newData.totalPrice = this.dataModel.totalPrice;
      newData.bpeItemId = this.dataModel.bpeItemId;
      newData.bonusPointCost = this.dataModel.bonusPointCost;
      newData.feeYear = this.dataModel.feeYear;
      newData.giftBalanceId = this.dataModel.giftBalanceId;
      newData.giftAmount = this.dataModel.giftAmount;
      newData.courseId = this.dataModel.courseId;

      this.dataForComponents.ocfWorkflowCard = newData;
    },
    next() {
      if (this.submitBtnDisable) return;
      if (
        this.dataModel.type ===
        this.GLOBAL.otherCollectFeeType.videoPackage.value
      ) {
        if (!this.dataModel.courseId) {
          this.$message.warning("请选择课程");
          return;
        }
      }

      this.triggerNext();
    },
    onValidateInit() {
      this.submitBtnDisable = true;
      this.submitBtnClass = "info";
    },
    onValidateDone(dataOut) {
      // console.log("onValidateDone: ", dataOut);
      this.submitBtnDisable = !dataOut.isValid;
      this.submitBtnClass = dataOut.isValid ? "primary" : "info";

      if (dataOut.isValid) {
        this.dataModel.type = dataOut.data.type;
        this.dataModel.feeYear = dataOut.data.feeYear;
        this.dataModel.subType = dataOut.data.subType;
        this.dataModel.studentId = dataOut.data.studentId;
        this.dataModel.phone = dataOut.data.phone;
        this.dataModel.comment = dataOut.data.comment;
        this.dataModel.amount = dataOut.data.amount;
        this.dataModel.quantity = dataOut.data.quantity;
        this.dataModel.totalPrice = dataOut.data.totalPrice;
        this.dataModel.bpeItemId = dataOut.data.bpeItemId;
        this.dataModel.bonusPointCost = dataOut.data.bonusPointCost;
        this.dataModel.giftBalanceId = dataOut.data.giftBalanceId;
        this.dataModel.giftAmount = dataOut.data.giftAmount;
        this.dataModel.courseId = dataOut.data.courseId;

        if (this.dataModel.type === 6){
          if (!this.dataModel.totalPrice){
            this.dataModel.totalPrice = this.dataModel.amount;
          }
        }
      }
    },
    getDataOut() {
      let result = {
        stepIndex: 0,
        data: this.dataModel,
      };

      return result;
    },
    hasDataChange() {
      let result =
        !this.submitBtnDisable &&
        JSON.stringify(this.dataModel) != JSON.stringify(this.oldDataModel);
      return result;
    },
    triggerNext() {
      let dataOut = this.getDataOut();
      this.$emit("next", dataOut);
    },
    onRedoWorkflow() {
      this.$router.replace(this.$route.name, {query: {}});
      this.$emit("reload");
    },
  },
  watch: {
    data: function (newVal) {
      this.initData(newVal);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/otherCollectFee/ocfWorkflowStep1.vue